// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cIgu","content":"styles_content__2k4lv","tableWrap":"styles_tableWrap__36lBE"};